





































import Vue from 'vue';
import StringButton from '../components/common/Button/StringButton.vue';
import Button from '../components/common/Button/Button.vue';
import Input from '../components/common/Input/Input.vue';
import NotificationText from '../components/common/NotificationText/NotificationText.vue';
import Spinner from '@/components/common/Spinner/Spinner.vue';

import axios from 'axios';
import { axiosApiInstance } from '../utils/axiosInstances';

/**
 * DEMO용 더미 계정 정보
 */
const demoUser = {
  userEmail: 'demo@aiqa.com',
  userPwd: 'F7hbrSZF',
};

export default Vue.extend({
  components: {
    Input,
    StringButton,
    Button,
    NotificationText,
    Spinner,
  },
  data(): {
    email: string;
    password: string;
    logInAlert: string;
  } {
    return {
      email: '',
      password: '',
      logInAlert: '',
    };
  },
  created() {
    // DEMO 자동 로그인
    this.onClickLoginButton();
  },
  methods: {
    onClickSignUpButton() {
      // this.$router.push('/signup');
    },
    onClickLoginButton() {
      this.$store.commit('startLoading');
      axios
        .post('/userapi/v1/login', {
          user_email: demoUser.userEmail,
          user_password: demoUser.userPwd,
        })
        .then((response) => {
          if (response.status === 201) {
            const responseResult = response.data.result;

            this.$store.commit('setToken', {
              accessToken: responseResult.accessToken,
              refreshToken: responseResult.refreshToken,
              userId: responseResult.user_id,
            });

            axiosApiInstance
              .get(`/userapi/v1/users/${responseResult.user_id}`)
              .then((response) => {
                if (response.status === 200) {
                  console.log(response.data);
                  this.$store.commit(
                    'setIsAdmin',
                    response.data.result.isAdmin,
                  );
                  this.$store.commit(
                    'setUserName',
                    response.data.result.user_name,
                  );
                }

                this.$store.commit('stopLoading');
                this.$router.push('/');
              })
              .catch((error) => {
                console.error(error);

                this.$store.commit('stopLoading');
                this.$router.push('/demo');
              });
          }
        })
        .catch((error) => {
          if (error.response) {
            // Request made and server responded
            if (error.response.status === 404) {
              this.logInAlert = '이메일을 확인해주세요.';
            } else if (error.response.status === 401) {
              this.logInAlert = '비밀번호를 확인해주세요.';
            } else {
              alert('잠시 후에 다시 시도해주세요.');
            }
          } else if (error.request) {
            // Request made but no response was received
            alert('잠시 후에 다시 시도해주세요.');
          } else {
            // Somethiing happened in setting up the request that triggered an error
            alert('에러가 발생했습니다.');
          }
          console.error(error);
          this.$store.commit('stopLoading');
          this.$router.push('/demo');
        });
    },
  },
});
